import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'jb-bff-booker-skeleton',
  templateUrl: './bff-booker-skeleton.component.html',
  styleUrls: ['./bff-booker-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BffBookerSkeletonComponent {}
